import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  :root {
    --font-light: ${({ theme }) => theme.text?.font.weights.light};
    --font-regular: ${({ theme }) => theme.text?.font.weights.regular};
    --font-medium: ${({ theme }) => theme.text?.font.weights.medium};
    --font-bold: ${({ theme }) => theme.text?.font.weights.bold};
  }
  body {
    font-family: ${({ theme }) => theme.text?.font.name}, sans-serif;
    color: ${({ theme }) => theme.text?.colours.body};
  }
`
